import {NgModule} from "@angular/core";
import {DxNavigatorComponent} from "./ui/components/navigator/dx-navigator.component";
import {DxHeadNavigationMenuComponent} from "./ui/components/navigator/head-navigation-menu/dx-head-navigation-menu.component";
import {DxSideNavigationMenuComponent} from "./ui/components/navigator/side-navigation-menu/dx-side-navigation-menu.component";
import {DxHeadDropdownPanelComponent} from "./ui/components/navigator/head-navigation-menu/dx-head-dropdown-panel/dx-head-dropdown-panel.component";
import {DxHeadDropdownTreeComponent} from "./ui/components/navigator/head-navigation-menu/dx-head-dropdown-tree/dx-head-dropdown-tree.component";
import {DxSideDropdownListComponent} from "./ui/components/navigator/side-navigation-menu/side-dropdown-list/dx-side-dropdown-list.component";
import {DxSideDropdownTreeComponent} from "./ui/components/navigator/side-navigation-menu/side-dropdown-tree/dx-side-dropdown-tree.component";
import {DxRouteNotFoundReportComponent} from "./ui/components/navigator/route-not-found-report/dx-route-not-found-report.component";
import {CommonModule} from "@angular/common";
import {DxContentMessageBoxComponent} from "./ui/components/navigator/content-message-box/dx-content-message-box.component";
import {RouterModule} from "@angular/router";

/**
 * Экспортирует функциональность для навигации по приложению:
 * 1.
 * 2.
 * ....
 */
@NgModule({
  declarations: [
    DxNavigatorComponent,
    DxHeadNavigationMenuComponent,
    DxHeadDropdownPanelComponent,
    DxHeadDropdownTreeComponent,
    DxSideNavigationMenuComponent,
    DxSideDropdownListComponent,
    DxSideDropdownTreeComponent,
    DxRouteNotFoundReportComponent,
    DxContentMessageBoxComponent
  ],
  exports: [
    DxNavigatorComponent,
    DxContentMessageBoxComponent
  ],
  imports: [
    CommonModule,
    RouterModule
  ],
  providers: [],
  bootstrap: []
})
export class DxNavigationModule {

}
